"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconChevronLeftRounded = function IconChevronLeftRounded(_ref) {
  var className = _ref.className,
      color = _ref.color;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "50",
    height: "50",
    viewBox: "0 0 50 50",
    fill: "none",
    className: className
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4142 10.5858C33.1953 11.3668 33.1953 12.6332 32.4142 13.4142L20.8284 25L32.4142 36.5858C33.1953 37.3668 33.1953 38.6332 32.4142 39.4142C31.6332 40.1953 30.3668 40.1953 29.5858 39.4142L16.5858 26.4142C15.8047 25.6332 15.8047 24.3668 16.5858 23.5858L29.5858 10.5858C30.3668 9.80474 31.6332 9.80474 32.4142 10.5858Z",
    fill: color
  }));
};

IconChevronLeftRounded.defaultProps = {
  color: 'black'
};
IconChevronLeftRounded.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconChevronLeftRounded;
exports.default = _default;